(function ($) {

    $(document).ready(function () {

        var mobileMenu = $('.JS--mobile-menu');

        $('.JS--open-mobile-menu').on('click', function () {

            mobileMenu.addClass('is-visible');
            $('body').addClass('mobile-open');

        });

        $('.JS--close-menu').on('click', function () {

            mobileMenu.removeClass('is-visible');
            $('body').removeClass('mobile-open');
        });

        $('.mobile-menu').children( '.menu-item-has-children' ).children('a').on('click', function () {
            console.log("test");
            $(this).toggleClass('has-back');
            $(this).siblings('.sub-menu-wrapper').toggleClass('is-visible');
            $(this).parent().siblings('.menu-item').toggle();
            $('.JS--menu-block').toggle();

        });

        $(window).on('resize', function () {
            if ($(window).width() >= 1400) {
                mobileMenu.removeClass('is-visible');
            }
        });




    });


})(jQuery);